import { OrderStatus } from './OrderStatus';
import { OrderProduct, orderProductFromResponse } from './OrderProduct';

export interface Order {
  id: number;
  createdAt: Date;
  paymentMethod: string;

  status: OrderStatus;
  statusFormatted: string;
  notes: string;
  affiliateCode?: string;
  visitorID?: string;
  errorCode?: string;
  errorMessage?: string;

  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
  customerPhone: string;
  taxOffice?: string;
  taxNumber?: string;
  customerCompany?: string;
  previousOrderCount: number;

  billingFirstName: string;
  billingLastName: string;
  billingAddress1: string;
  billingAddress2?: string;
  billingCity: string;
  billingState: string;
  billingZip?: string;
  billingCountry: string;

  shippingFirstName: string;
  shippingLastName: string;
  shippingAddress1: string;
  shippingAddress2?: string;
  shippingCity: string;
  shippingState: string;
  shippingZip?: string;
  shippingCountry: string;

  products: OrderProduct[];

  shippingMethod: string;
  cargoNo?: string;
  cargoKey?: string;
  cargoUrl?: string;
  cargoStatus?: string;

  offerID?: number;
  subtotalAmount: number;
  pointUsage: number;
  discount: number;
  shippingAmount: number;
  totalAmount: number;
}

export const orderFromResponse = (responseData: any): Order => ({
  id: responseData.id,
  createdAt: new Date(responseData.created_at),
  paymentMethod: responseData.payment_method,

  status: responseData.status,
  statusFormatted: responseData.status_formatted,
  notes: responseData.notes,
  affiliateCode: responseData.affiliate_code,
  visitorID: responseData.visitor_id,
  errorCode: responseData.error_code,
  errorMessage: responseData.error_message,

  customerFirstName: responseData.customer_first_name,
  customerLastName: responseData.customer_last_name,
  customerEmail: responseData.customer_email,
  customerPhone: responseData.customer_phone,
  taxOffice: responseData.tax_office,
  taxNumber: responseData.tax_number,
  customerCompany: responseData.customer_company,
  previousOrderCount: responseData.previous_order_count,

  billingFirstName: responseData.billing_first_name,
  billingLastName: responseData.billing_last_name,
  billingAddress1: responseData.billing_address_1,
  billingAddress2: responseData.billing_address_2,
  billingCity: responseData.billing_city,
  billingState: responseData.billing_state,
  billingZip: responseData.billing_zip,
  billingCountry: responseData.billing_country,

  shippingFirstName: responseData.shipping_first_name,
  shippingLastName: responseData.shipping_last_name,
  shippingAddress1: responseData.shipping_address_1,
  shippingAddress2: responseData.shipping_address_2,
  shippingCity: responseData.shipping_city,
  shippingState: responseData.shipping_state,
  shippingZip: responseData.shipping_zip,
  shippingCountry: responseData.shipping_country,

  products: (responseData.products ?? []).map((product: any) =>
    orderProductFromResponse(product),
  ),

  shippingMethod: responseData.shipping_method,
  cargoNo: responseData.cargo_no,
  cargoKey: responseData.cargo_key,
  cargoUrl: responseData.cargo_url,
  cargoStatus: responseData.cargo_status,

  offerID: responseData.offer_id,
  subtotalAmount: responseData.subtotal_amount,
  pointUsage: responseData.point_usage,
  discount: responseData.discount_amount,
  shippingAmount: responseData.shipping_amount,
  totalAmount: responseData.total_amount,
});
